module.exports = __webpack_public_path__ + "img/cooler-master.7c189511.png";